module.exports = __webpack_public_path__ + "assets/2e536ba88bf440b30dd561a32a2c865c.mp3";